const cacheStore = new Map()

export function setCache(key, data, ttl = 300000) {
  cacheStore.set(key, {
    data,
    timestamp: Date.now(),
    ttl
  })
}

export function getCache(key) {
  const item = cacheStore.get(key)
  if (!item) return null
  
  if (Date.now() - item.timestamp > item.ttl) {
    cacheStore.delete(key)
    return null
  }
  
  return item.data
}

export function clearCache(key) {
  cacheStore.delete(key)
}

export function clearAllCache() {
  cacheStore.clear()
}

export function hasCache(key) {
  const item = cacheStore.get(key)
  if (!item) return false
  
  if (Date.now() - item.timestamp > item.ttl) {
    cacheStore.delete(key)
    return false
  }
  
  return true
}

export { cacheStore }